import isObject from 'lodash/isObject';

export default class GreenOption {
  /**
   * @param {Object.<string, string>} props - properties to own upon instantiation
   */
  constructor(props) {
    Object.assign(this, props);
  }

  /**
   * Create a new `GreenOption` instance. The properties in `instanceSeed`
   * will be shallow-merged as properties of the new instance.
   *
   * @param {Object} instanceSeed
   * @return {GreenOption}
   */
  static create(instanceSeed) {
    if (!instanceSeed) {
      throw new ReferenceError('missing required argument instanceSeed');
    }

    if (isObject(instanceSeed) === false) {
      throw new TypeError('argument instanceSeed was not of required type "Object"');
    }

    return new this(instanceSeed);
  }

  static createFromServerFormat(rawInstance) {
    if (!rawInstance) {
      throw new ReferenceError('missing required argument rawInstance');
    }

    if (isObject(rawInstance) === false) {
      throw new TypeError('argument rawInstance was not of required type "Object"');
    }

    return GreenOption.create({
      approxCost: rawInstance.approxCharge,
      greenAmount: rawInstance.percent,
      extraCost: {
        amount: rawInstance.extraCost,
        unit: rawInstance.extraUnit,
      },
    });
  }
}
